// src/pages/gas/GASWalkInEntry.jsx
import React, { useState } from "react";

const GASWalkInEntry = () => {
  const [walkIns, setWalkIns] = useState([
    {
      id: "WALK-001",
      purpose: "Vendor Follow-up",
      time: "11:15 AM",
      outcome: "Positive",
    },
    {
      id: "WALK-002",
      purpose: "Client Inquiry",
      time: "01:40 PM",
      outcome: "Neutral",
    },
  ]);

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h1 className="text-xl font-semibold mb-4">Walk-in Entry</h1>

      {/* Walk-in Form */}
      <div className="border border-cyan-700 rounded-xl p-4 mb-6">
        <h2 className="text-sm font-semibold mb-3">New Walk-in</h2>

        <input
          className="w-full mb-3 px-3 py-2 bg-black border border-cyan-600 rounded text-sm"
          placeholder="Purpose of Visit"
        />

        <select className="w-full mb-3 px-3 py-2 bg-black border border-cyan-600 rounded text-sm">
          <option>Initial</option>
          <option>Escalation</option>
        </select>

        <button className="w-full bg-cyan-600 text-black py-2 rounded font-semibold">
          Log Walk-in
        </button>
      </div>

      {/* Walk-in Logs */}
      <h2 className="text-sm font-semibold mb-2">Recent Walk-ins</h2>

      {walkIns.map((item) => (
        <div
          key={item.id}
          className="border border-cyan-800 rounded-lg p-3 mb-3 text-sm"
        >
          <div className="flex justify-between">
            <span>{item.purpose}</span>
            <span className="text-gray-400">{item.time}</span>
          </div>
          <div className="text-xs text-cyan-300">
            Outcome: {item.outcome}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GASWalkInEntry;
